module.exports = __webpack_public_path__ + "img/PM_7.ce247ce3.svg";